<!-- 项目文件 -->
<template>
  <div class="w100p minw1260">
    <div class="bg000 h30 lh30">
      <ul class="w1260 mauto">
        <router-link to="School" tag="a" target="_blank">
          <li class="disinblock mr10  cb8b8 fs12 " :class="{'aaaa':Color==3}"> 驾校 </li> 
        </router-link>
        <router-link to="Carhome" tag="a" target="_blank">
          <li class="disinblock mr10  cb8b8 fs12 cursor"  :class="{'aaaa':Color==1}"> 学员 </li>
        </router-link>
        <router-link to="Cooperation" tag="a" target="_blank">
            <li class="disinblock mr10 cb8b8 fs12 cursor" :class="{'aaaa':Color==2}"> 合作伙伴 </li>
        </router-link>
      </ul>
    </div>

    <div class="bg1f8 h60 lh60">
      <div class="w1260 mauto overhidden">
        <span class="h60 floatl mr20 alit" v-if="Logo=='school' ">
            <img class="h22 w84" src="../../public/img/logo.png">
            <router-link to="School">
            <span class="fs18 cfff pl10 ml10 lh30 h30 borderlfff disinblock">
              驾校服务
            </span>
          </router-link>
        </span>
        <span class="h60 floatl mr20 alit"  v-if="Logo=='home' ">
            <img class="h22 w84" src="../../public/img/logo.png">
            <router-link to="Carhome">
            <span class="fs18 cfff pl10 ml10 lh30 h30 borderlfff disinblock ">
              学车之家
            </span>
          </router-link>
        </span>
        <span class="h60 floatl mr20 alit" v-if="Logo=='coop' ">
          <img class="h22 w84" src="../../public/img/logo.png">
          <router-link to="Cooperation">
            <span class="fs18 cfff pl10 ml10 lh30 h30 borderlfff disinblock ">
              合作伙伴
            </span>
          </router-link>
        </span>

        <ul class="disinblock floatl ml20" v-if="TitleList==0">
          <router-link to="/">
            <li class="disinblock mr20 ml20 cfff fs14 floatl"> 首页 </li>
          </router-link>
          <router-link to="Smallprogram"  >
            <li class=" disinblock mr20 ml20 cfff fs14 floatl">招生系统</li>
          </router-link>
          <router-link to="System"  >
            <li class=" disinblock mr20 ml20 cfff fs14 floatl">培训系统</li>
          </router-link>
          <router-link to="Wemedia" >
            <li class=" disinblock mr20 ml20 cfff fs14 floatl">自媒体运营</li>
          </router-link>
          <router-link to="Meltmedia"  >
            <li class=" disinblock mr20 ml20 cfff fs14 floatl">融媒体推广</li>
          </router-link>
        </ul>
        <ul class="disinblock floatl ml20"  v-if="TitleList==1">
            <router-link to="/" >
              <li class="disinblock mr20 ml20 cfff fs14 floatl"> 首页 </li>
            </router-link>
            <router-link to="Smallprogram" >
              <li class=" disinblock mr20 ml20 cfff fs14 floatl">招生系统</li>
            </router-link>
            <router-link to="System" >
              <li class=" disinblock mr20 ml20 cfff fs14 floatl">培训系统</li>
            </router-link>
            <router-link to="Wemedia">
              <li class=" disinblock mr20 ml20 cfff fs14 floatl">自媒体运营</li>
            </router-link>
            <router-link to="Meltmedia">
              <li class=" disinblock mr20 ml20 cfff fs14 floatl">融媒体推广</li>
            </router-link>

        </ul>
        <ul class="disinblock floatl ml20" v-if="TitleList==3">
          <router-link to="/">
            <li class="disinblock mr20 ml20 cfff fs14 floatl"> 首页 </li>
          </router-link>

          <router-link to="DriveSystem"> 
            <li class="disinblock mr20 ml20 cfff fs14 floatl cursor"  > 驾培系统 </li>
          </router-link>
          <router-link to="SmallMark">
            <li class="disinblock mr20 ml20 cfff fs14 floatl cursor"> 小程序营销系统 </li>
          </router-link>
          <router-link to="addvalue">
            <li class="disinblock mr20 ml20 cfff fs14 floatl cursor" > 增值业务 </li>
          </router-link>
          <router-link to="Flow">
            <li class="disinblock mr20 ml20 cfff fs14 floatl cursor" > 流量经营 </li>
          </router-link>
          <router-link to="Businesscoop">
            <li class="disinblock mr20 ml20 cfff fs14 floatl cursor"> 业务合作 </li>
          </router-link>

        </ul>
        <ul class="disinblock floatl ml20" v-if="TitleList==4">
          <router-link to="/" tag="a" target="_blank">
            <li class="disinblock mr20 ml20 cfff fs14 floatl"> 首页 </li>
          </router-link>
        
            <li class="disinblock mr20 ml20 cfff fs14 floatl cursor"  @click="Toreschool()"> 驾校报名 </li>
        
         
            <li class="disinblock mr20 ml20 cfff fs14 floatl cursor"  @click="Toxuexi()" v-if="newYm==1"> 理论学习 </li>
          
          <router-link :to="{path:'Carhome?#xuexi',query:{studytype:'1'}}" v-else>
            <li class="disinblock mr20 ml20 cfff fs14 floatl cursor"> 理论学习 </li>
          </router-link>
          <router-link to="News" >
            <li class="disinblock mr20 ml20 cfff fs14 floatl "  > 学车资讯 </li>
          </router-link>
          <router-link to="Video">
            <li class="disinblock mr20 ml20 cfff fs14 floatl"> 学车视频 </li>
          </router-link>
          <router-link to="Guide">
            <li class="disinblock mr20 ml20 cfff fs14 floatl"> 学车指南 </li>
          </router-link>
        </ul>
        <div class="floatr" v-if="Link==0">
 
          <span class="br20 pt5 pb5 pl12 pr12 borderfff mr20">
            <a class="cfff fs14"  target="_blank" href="http://jiaxiao.yixueyijia.com/">登录后台</a>
          </span>
         
            <span class="br20 pt5 pb8 pl12 pr12 borderfff cfff fs14 cursor" @click="open1()">
                <i class="vermid  cfff fs14" >申请入驻</i>
            </span>
          
        </div>
        <div class="floatr h60 alit" v-if="Link==1">
          <span class="br20 pt5 pb5 pl12 pr12 h20 alit borderfff mr20">
            <a class="cfff fs14" target="_blank" href="http://manage.yixueyijia.com/partner_manage/admin/login">加盟商登录</a>
          </span>
        
            <span class="br20 pt5 pb5 h20 alit pl12 pr12 borderfff cfff fs14 cursor"  @click="foo()">
              <i class="vermid  cfff fs14">合作申请</i>
            </span>
       
        </div>
        <div class="floatr h60 alit" v-if="Link==2">
          <span class="br20 alit h20 pt5 pb8 pl12 pr12  borderfff mr20 cfff fs14 cursor"  @click.stop="onOpen()">
            <img class="h16 w11 vermid" src="../../public/img/img52.png">
            <i class="vermid cfff fs14 pl3">{{city || '暂无' }}</i>

          </span>
   
         
        </div>
      </div>
    </div>
    <div class="w100p fs0 ">
          <img class=" w100p" :src="img">
    </div>

    <!-- 确认提交弹框 -->
    <div class="posfix bgrg w100p h100p zindex999 pl10 pr10 overflow top0 left0" v-show="mask==1">
      <div class="posab left30p top30p bgfff w30p pt20 pb20 pl40 pr40 bradius8">
        <p class=" fbold fs20 c1f8 textc">申请入驻</p>
        <span @click="choose()" class="disinblock posab top0 right11 fs26 c333 cursor"> × </span>
        <div class="pt20 pb20">
          <p class="posre bradius8 baee h40 alit mt20 mb20">
            <span class="posab pr12 pl12 "><img class="w16 h16" src="../../public/img/css.png"></span>
            <input v-model="School" class="textindent2 baee bradius8 w100p h100p borderno outline" type="text"
              placeholder="请输入驾校...">
          </p>
          <p class="posre bradius8 baee h40 alit mt20 mb20">
            <span class="posab pr12 pl12 "><img class="w10 h14" src="../../public/img/img97.png"></span>
            <input v-model="Name" class="textindent2 baee bradius8 w100p h100p borderno outline" type="text"
              placeholder="请输入姓名...">
          </p>
          <p class="posre bradius8 baee h40 alit mt20 mb20">
            <span class="posab  pr12 pl12 "><img class="w10 h14" src="../../public/img/img98.png"></span>
            <input v-model="Phone" class="textindent2 baee bradius8 w100p h100p borderno outline" type="text"
              placeholder="请输入手机号...">
          </p>
          <p @click="sentApply()" class=" h50 lh50 bradius8 cursor mt20 mb20 cfff bg1f8 textc fbold fs18 ">
            确认提交
          </p>
        </div>
      </div>
    </div>
    <!-- 加盟代理弹框 -->
    <div class="posfix bgrg w100p h100p zindex999 pl10 pr10 overflow top0 left0 alit flexc" v-show="jmmask==1">
    
      <div class="posab zindex999  bgfff  w30p pt20 pb20 pl40 pr40 bradius8 ">
        <p class=" fbold fs20 c1f8 textc">合作申请</p>
        <span @click="jmchoose()" class="disinblock posab top0 right11 fs26 c333 cursor"> × </span>
        <div class="pt20 pb20">
          <p class="posre bradius8 baee h40 alit mt20 mb20">
            <span class="posab pr12 pl12 "><img class="w10 h14" src="../../public/img/img97.png"></span>
            <input v-model="jmName" class="c999 textindent2 baee bradius8 w100p h100p borderno outline" type="text"
              placeholder="请输入姓名...">
          </p>
          <p class="posre bradius8 baee h40 alit mt20 mb20">
            <span class="posab  pr12 pl12 "><img class="w10 h14" src="../../public/img/img98.png"></span>
            <input v-model="jmPhone" class="c999 textindent2 baee bradius8 w100p h100p borderno outline" type="text"
              placeholder="请输入手机号...">
          </p>

            <p class="posre  h40  mt20 mb20 baee bradius8 lh40" v-if="Waytype==1">
            
              
                <span class="fs12 c999 disinblock pl15" value="0">
                  加盟代理
                </span>

            </p>

          <p class="posre  h40 alit mt20 mb20" v-else>
            <select v-model="jmselecWay" class="w100p textindent_5 baee bradius8 w100p h100p borderno outline fs12 c999">
              <!-- <option value="" class="disabled selected hidden fs12 " value="2">请选择方式</option> -->
              <option value="" disabled selected hidden>请选择方式</option>
              <option class="pb5 pt5 h50 fs12 " value="0">
                加盟代理
              </option>
              <option class="pb5 pt5 h50 fs12 " value="1">
                异业合作
              </option>
            </select>
          </p>


          <p class="posre bradius8  h40 alit mt20 mb20">
            <v-distpicker hide-area @selected='selected' class="fs12 c999"></v-distpicker>
          </p>
    
          <p @click="jmsentApply()" class=" h50 lh50 bradius8 cursor mt20 mb20 cfff bg1f8 textc fbold fs18 ">
            确认提交
          </p>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
    import Slider from '@/components/Slider'
    import $ from "jquery";
    import VDistpicker from 'v-distpicker'
    export default {
        props: ['img', 'city', 'Color', 'TitleList', 'Logo', "Link", "iscity1", "newYm", 'Waytype'],

        data() {
            return {

                open: true,
                mask: 0,
                Name: '',
                Phone: '',
                School: '',
                show: true,
                Phone1: '',
                Code: '',
                count: '',
                timer: null,
                pass: 0,
                city1: '',
                jmmask: 0, //加盟
                jmName: '',
                jmPhone: '',
                jmProvince: '',
                jmCity: '',
                jmway: '',
                jmselecWay: '',

            };
        },
        components: {
            Slider,
            VDistpicker
        },
        methods: {
            foo() {
                this.jmmask = 1;
                $('body').css("overflow", "hidden")
            },
            jmchoose() {
                this.jmmask = 0;
                $('body').css("overflow", "auto")
            },
            jmsentApply() {
                let that = this;

                if (that.Waytype == 1) {
                    that.jmselecWay = 0;
                }

                if (that.jmName == "" || !(/^1[23456789]\d{9}$/.test(that.jmPhone)) || that.jmselecWay == null || that.jmselecWay == '' || this.jmCity == undefined) {
                    alert('请正确填写');
                    return 0;
                } else {

                    $.ajax({
                        type: "POST",
                        url: that.beseSend + "/openapi/partnershipand/insterPartnershipand.json",
                        dataType: "json",
                        async: false,
                        data: {
                            "name": that.jmName,
                            "phone": that.jmPhone,
                            "province": that.jmProvince,
                            "city": that.jmCity,
                            "way": that.jmselecWay
                        },
                        success: function(data) {
                            alert(data.resultObj.info)
                            that.choose();
                            that.jmName = "";
                            that.jmPhone = "";

                        },
                        error: function(data) {
                            console.log(data);
                        }
                    });
                }
            },
            selected(data) {
                this.Province = data.province.value;
                this.City = data.city.value;
            },
            onOpen() {
                this.$emit('childFn', this.open);
            },
            Tosub2(index) { //科一顺序
                let that = this;
                let Tosub2 = this.$router.resolve({
                    path: "/SubjectDetail2",
                    query: {
                        tiku: index,
                        subject: 1,
                        obj: 'shunxu'
                    }
                });
                window.open(Tosub2.href, '_blank');
            },
            Toreschool() {
                let that = this;
                let cityIDD = that.$store.state.cityIDX.name;

                this.$router.push({
                    path: "/Reschool",
                    query: {
                        cityid: cityIDD,

                    }
                });

            },
            open1() {
                this.mask = 1;
                $('body').css("overflow", "hidden")
            },
            choose() {
                this.mask = 0;
                $('body').css("overflow", "auto")
            },

            sentApply() {
                let that = this;

                if (that.Name == "" || that.School == "" || !(/^1[23456789]\d{9}$/.test(that.Phone))) {
                    alert('请正确输入');
                    return 0;
                } else {
                    $.ajax({
                        type: "POST",
                        url: that.beseSend + "/openapi/drivingin/insterDrivingin.json",
                        dataType: "json",
                        async: false,
                        data: {
                            "name": that.Name,
                            "phone": that.Phone,
                            'belongstoschool': that.School,
                            'channel': 'exejapp'
                        },
                        success: function(data) {
                            alert(data.resultObj.info)
                            that.choose();
                            that.Name = "";
                            that.Phone = "";
                            that.School = "";
                        },
                        error: function(data) {
                            console.log(data);
                        }
                    });
                }

            },


            Toxuexi() {
                document.querySelector("#xuexi").scrollIntoView(true)
            },


            Del() {
                var v = this;
                var map = new BMap.Map("container");
                var nowCity = new BMap.LocalCity();
                nowCity.get(bdGetPosition);

                function bdGetPosition(result) {

                    v.city1 = result.name
                }
            },
        },
        created() {
            this.Del();

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bgrg {
        background: rgba(0, 0, 0, 0.5);
    }
    
    .bg156 {
        background-image: url('../../public/img/img156.png');
        background-repeat: no-repeat;
        background-size: 100%;
        background-color: #5183f7;
    }
    
    input::-webkit-input-placeholder {
        /* placeholder颜色  */
        color: #999
    }
    
    .gradient-text-one {
        background-image: linear-gradient(to right, #6ebeff, #5087ff);
    }
    
    .aaaa {
        color: #1f82f6;
        font-weight: 600;
    }
    
    /deep/ .distpicker-address-wrapper {
        width: 100%;
    }
    
    /deep/ .distpicker-address-wrapper select {
        outline: none;
        border-radius: 8px;
        width: 49%;
        font-size: 12px;
        color: #999;
    }
</style>